<template>
  <TopBar />
  <!-- 背景图片 -->
  <img
    class="background"
    v-if="resourceStore.backgroundImage"
    :src="resourceStore.backgroundImage"
    alt="背景图"
  />

  <!-- 主容器 -->
  <div class="home-container">
    <!-- Logo 部分 -->
    <div class="logo-container">
      <!-- <img class="logo" src="@/assets/logo.png" alt="Logo" /> -->

      <div class="easylink">
        <span class="green">Easy</span><span class="white">Link</span
        ><span class="green">.cc</span>
      </div>
      <div class="title">简单云链</div>
    </div>

    <!-- 上传按钮 -->
    <UploadButton />

    <!-- 文件链接输入框 -->
    <!-- <FileInput /> -->

    <!-- Android 微信浏览器提示 -->
    <div v-if="isAndroidWeChat" class="wechat-tip">
      注意：微信内功能受限，建议使用手机浏览器访问
    </div>
  </div>

  <!-- 上传结果弹窗 -->
  <UploadDialog />

  <!-- 备案信息 -->
  <div class="beian-container">
    <!-- 公安备案信息 -->
    <a
      class="beian"
      href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502056667"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img :src="beianIcon" alt="公安备案" class="beian-icon" />
      京公网安备11010502056667号
    </a>
    
    <!-- ICP 备案信息 -->
    <a
      class="beian"
      href="https://beian.miit.gov.cn/"
      target="_blank"
      rel="noopener noreferrer"
      >京ICP备19046909号-2</a
    >
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import UploadDialog from "./components/UploadDialog.vue";
import Tracking from "@/model/tracking.js";
import UploadButton from "./components/UploadButton.vue";
import { useResourceStore } from "@/store/resourceStore";
import TopBar from "./components/TopBar.vue";
// import FileInput from "./components/FileInput.vue";
import beianIcon from "@/assets/beian.png"; // 导入公安备案图标

const resourceStore = useResourceStore();
const isAndroidWeChat = ref(false);

onMounted(() => {
  // 检测是否为Android微信浏览器
  const userAgent = navigator.userAgent.toLowerCase();
  isAndroidWeChat.value =
    userAgent.includes("android") && userAgent.includes("micromessenger");

  Tracking.send({
    trigger: "page-view",
    page: "main-page",
  });
});
</script>

<style scoped lang="scss">
.background {
  position: fixed;
  object-fit: cover;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
}

.beian-container {
  position: fixed;
  bottom: px2rem(5);
  right: px2rem(10);
  display: flex;
  flex-direction: row;
  gap: px2rem(10);
  
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-end;
    gap: px2rem(5);
  }
}

.beian {
  font-size: px2rem(12);
  color: #fff;
  text-decoration: none;
  opacity: 0.2;
  display: flex;
  align-items: center;
  
  &:hover {
    opacity: 0.5;
  }
  
  .beian-icon {
    height: px2rem(14);
    margin-right: px2rem(4);
  }
}

.home-container {
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  left: 11.98vw;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: left;

  .logo-container {
    .easylink {
      position: relative;
      font-size: px2rem(34);
      font-family: "LingWai SC Medium";
      line-height: px2rem(34);
      margin-bottom: px2rem(12);

      &::before {
        content: "";
        display: block;
        height: px2rem(133);
        pointer-events: none;

        @media screen and (max-width: 768px) {
          height: px2rem(30);
        }
      }

      .green {
        color: #00ff45;
      }

      .white {
        color: white;
      }
    }

    .title {
      font-size: px2rem(64);
      color: white;
      font-family: "LingWai SC Medium";
    }

    &:hover {
      @media screen and (min-width: 769px) {
        transition: all 0.15s linear;
        margin-left: 1vw;
      }
    }
  }
}

.wechat-tip {
  margin-top: px2rem(20);
  padding: px2rem(10);
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: px2rem(4);
  color: #fff;
  font-size: px2rem(14);
  text-align: center;
}
</style>
